import {useMemo} from 'react'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {AutomatedCommentSource} from '@github-ui/diff-lines/conversation-types'

export function useAutomatedReviewCommentActions(automatedComment: {
  isDismissed: boolean
  viewerCanDismiss: boolean
  viewerCanReopen: boolean
  source: string
}) {
  return useMemo(() => {
    const isDismissed = automatedComment.isDismissed
    const isDismissable = !isDismissed && automatedComment.viewerCanDismiss
    const isReopenable = isDismissed && automatedComment.viewerCanReopen

    let resourceName = 'alert'
    if (automatedComment.source === AutomatedCommentSource.CodeQuality) {
      resourceName = 'finding'
    }
    const toggleButtonLabel = isDismissed ? `Reopen ${resourceName}` : `Dismiss ${resourceName}`

    return {
      isDismissed,
      isDismissable,
      isReopenable,
      resourceName,
      toggleButtonLabel,
    }
  }, [automatedComment])
}
